const fixHeadingString = (string:string)=>{


    return string.replaceAll("<br>"," ")
}

export default fixHeadingString